import Select from 'react-select';
import { ChevronDown, Info } from 'lucide-react';
import cih from '../../../images/cih.png'
import aw from '../../../images/aw.png'
import bmce from '../../../images/bmce.png'
import bmci from '../../../images/bmci.png'
import sgmb from '../../../images/sgmb.png'
import bp from '../../../images/bp.png'
import cdm from '../../../images/cdg.png'
import cam from '../../../images/cpb.png'

import { useLanguage } from '../../../context/LanguageProvider';
import { useTheme } from '../../../context/ThemeProvider';

export default function BankSelect({ formData, handleChange, errors, type }) {
  const { t } = useLanguage();
  const { isDark } = useTheme();

  const bankOptions = [
    {
      value: 'CIH',
      label: (
        <div className="flex items-center">
          <img src={cih} alt="CIH" width={16} height={16} className="w-5 h-5 mx-2" />
          CIH
        </div>
      ),
      icon: cih
    },
    {
      value: 'Attijariwafa Bank',
      label: (
        <div className="flex items-center">
          <img src={aw} alt="Attijariwafa" width={16} height={16} className="w-5 h-5 mx-2" />
          Attijariwafa Bank
        </div>
      ),
      icon: aw
    },
    {
      value: 'BMCE',
      label: (
        <div className="flex items-center">
          <img src={bmce} alt="BMCE" width={16} height={16} className="w-5 h-5 mx-2" />
          BMCE
        </div>
      ),
      icon: bmce
    },
    {
      value: 'BMCI',
      label: (
        <div className="flex items-center">
          <img src={bmci} alt="BMCI" width={16} height={16} className="w-5 h-5 mx-2" />
          BMCI
        </div>
      ),
      icon: bmci
    },
    {
      value: 'Société Générale Maroc',
      label: (
        <div className="flex items-center">
          <img src={sgmb} alt="SGMB" width={16} height={16} className="w-5 h-5 mx-2" />
          Société Générale Maroc
        </div>
      ),
      icon: sgmb
    },
    {
      value: 'Banque Populaire',
      label: (
        <div className="flex items-center">
          <img src={bp} alt="BP" width={16} height={16} className="w-5 h-5 mx-2" />
          Banque Populaire
        </div>
      ),
      icon: bp
    },
    {
      value: 'Crédit du Maroc',
      label: (
        <div className="flex items-center">
          <img src={cdm} alt="CDM" width={16} height={12} className="w-5 h-4 mx-2" />
          Crédit du Maroc
        </div>
      ),
      icon: cdm
    },
    {
      value: 'Crédit Agricole du Maroc',
      label: (
        <div className="flex items-center">
          <img src={cam} alt="CAM" width={16} height={16} className="w-5 h-5 mx-2" />
          Crédit Agricole du Maroc
        </div>
      ),
      icon: cam
    },
    {
      value: 'Autre',
      label: <div className="flex items-center">Autre</div>,
      icon: null
    }
  ]
  

  const customComponents = {
    DropdownIndicator: ({ ...props }) => (
      <ChevronDown size={15} className="text-gray-500 mr-2 " />
    ),
    IndicatorSeparator: () => null,
    Option: ({ children, ...props }) => (
      <div {...props.innerProps} className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
        {children}
      </div>
    ),
    SingleValue: ({ children, ...props }) => {
      const option = bankOptions.find(opt => opt.value === props.data.value);
      return (
        <div className="flex items-center">
          {option && (
            <>
            {
              option.icon ?
              <img 
                src={option.icon}
                alt={option.value}
                width={16}
                height={16}
                className="w-5 h-5 mr-2"
              />
              :
              ""
            }
              {option.value}
            </>
          )}
        </div>
      );
    }
  };

  return (
    <div className='cursor-pointer font-cairo'>
      {
        type &&
        <label htmlFor="nameBank" className="block text-xs font-semibold text-gray-700 mb-2">
          {t('auth.bank_name_label')} <span className="text-red-500">*</span>
        </label>
      }
      <div className="relative ">
        <Select
          id="nameBank"
          name="nameBank"
          value={bankOptions.find(option => option.value === formData.nameBank)}
          onChange={(selectedOption) => {
            handleChange({
              target: {
                name: 'nameBank',
                value: selectedOption?.value || ''
              }
            });
          }}
          options={bankOptions}
          formatOptionLabel={(option) => option.label}
          placeholder={t('auth.bank_placeholder')}
          className={`react-select-container outline-none text-xs ${errors.name_bank ? 'border-red-400' : 'border-gray-200'}`}
          classNamePrefix="react-select"
          components={customComponents}
          required
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: errors.name_bank
                ? '#f87171'
                : isDark
                ? '#1C1917'
                : '#e5e7eb',
              borderRadius: '0.75rem',
              backgroundColor: isDark ? '#1C1917' : '#f9fafb',
              padding: '0.4rem 0.25rem',
              minHeight: 'auto',
              boxShadow: state.isFocused
                ? '0 0 0 2px rgba(10, 179, 156, 0.2)'
                : 'none',
              '&:hover': {
                borderColor: errors.name_bank
                  ? '#f87171'
                  : 'var(--color-primary-500)',
              },
            }),

            menu: (base) => ({
              ...base,
              backgroundColor: isDark ? '#1C1917' : '#ffffff',
              border: `1px solid ${isDark ? '#374151' : '#e5e7eb'}`,
              overflow: 'hidden',
            }),

            menuList: (base) => ({
              ...base,
              backgroundColor: isDark ? '#1C1917' : '#ffffff',
              color: isDark ? '#ffffff' : '#1C1917',
            }),

            option: (base, state) => ({
              ...base,
              fontSize: '0.75rem',
              padding: '0.5rem 0.75rem',
              backgroundColor: state.isSelected
                ? 'var(--color-primary-500)'
                : state.isFocused
                ? isDark
                  ? '#1f2937'
                  : '#f3f4f6'
                : 'transparent',
              color: state.isSelected
                ? '#fff'
                : isDark
                ? '#f3f4f6'
                : '#374151',
              cursor: 'pointer',
            }),

            placeholder: (base) => ({
              ...base,
              fontSize: '0.75rem',
              color: isDark ? '#9ca3af' : '#9ca3af',
            }),

            singleValue: (base) => ({
              ...base,
              fontSize: '0.75rem',
              color: isDark ? '#f3f4f6' : '#374151',
            }),

            input: (base) => ({
              ...base,
              fontSize: '0.75rem',
              color: isDark ? '#f3f4f6' : '#374151',
            }),

            indicatorSeparator: () => ({
              display: 'none',
            }),

            dropdownIndicator: (base) => ({
              ...base,
              color: isDark ? '#9ca3af' : '#6b7280',
              '&:hover': {
                color: 'var(--color-primary-500)',
              },
            }),
          }}
        />
        {errors.name_bank && (
          <p className="text-red-500 text-xs mt-1 flex items-center">
            <Info className="w-3 h-3 ml-1 inline-block" /> {errors.name_bank}
          </p>
        )}
      </div>
    </div>
  );
};